import { GraphType } from '@/graphql/types';

// Keep this explicit list because UI button order differs from enum declaration order.
export const GRAPH_TYPE_ORDER: GraphType[] = [
    GraphType.Step,
    GraphType.Line,
    GraphType.Bar,
    GraphType.Dot,
];
